var exports = {
  "k": "NotificationsTabInline.module__container___TjlXTD",
};

module.exports = exports;
